import { render, staticRenderFns } from "./AddBnpNotification.vue?vue&type=template&id=3b29a4bc&"
import script from "./AddBnpNotification.vue?vue&type=script&lang=js&"
export * from "./AddBnpNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports